import React from 'react';

// 画像の静的インポートの例
import commonLogo from '../../assets/common/logo.png';
import logoSvg from '../../assets/logo.svg';
import companySvg from '../../assets/common/company.svg';
// サイドバー画像のインポート
import sidebarAgentList from '../../assets/sidebar/agent_list.png';
import sidebarAiScore from '../../assets/sidebar/ai_score.png';
import sidebarEdit from '../../assets/sidebar/edit.png';
import sidebarSlide from '../../assets/sidebar/slide.png';

// 事前にインポートされた画像マッピング
const STATIC_IMAGES = {
  common: {
    'logo.png': commonLogo,
    'logo.svg': logoSvg,
    'company.svg': companySvg,
  },
  sidebar: {
    'agent_list.png': sidebarAgentList,
    'ai_score.png': sidebarAiScore,
    'edit.png': sidebarEdit,
    'slide.png': sidebarSlide,
  },
  // 他のカテゴリーの画像も必要に応じて追加
} as const;

// サポートするカテゴリーの型
type ImageCategory = keyof typeof STATIC_IMAGES;

// コンポーネントのProps
interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  /**
   * 画像カテゴリー（assetsディレクトリ内のサブディレクトリ）
   */
  category: ImageCategory;
  
  /**
   * 画像ファイル名（拡張子含む）
   */
  fileName: string;
  
  /**
   * 画像の代替テキスト
   */
  alt?: string;
  
  /**
   * CSSクラス名
   */
  className?: string;
}

/**
 * アセット画像を表示するためのコンポーネント
 * 静的インポートを使用して画像を表示します
 * 
 * @example
 * // common/logo.pngを表示
 * <Image category="common" fileName="logo.png" alt="ロゴ" />
 */
const Image: React.FC<ImageProps> = ({
  category,
  fileName,
  alt = '',
  className = '',
  ...props
}) => {
  // 静的インポートされた画像を取得
  const categoryImages = STATIC_IMAGES[category];
  
  if (!categoryImages || !categoryImages[fileName as keyof typeof categoryImages]) {
    console.warn(`画像が見つかりません: ${category}/${fileName}`);
    return null;
  }
  
  const image = categoryImages[fileName as keyof typeof categoryImages];
  
  return (
    <img 
      src={image}
      alt={alt}
      className={className}
      {...props}
    />
  );
};

export default Image;

/**
 * 使用例：
 * 
 * import Image from '../../components/common/Image';
 * 
 * // コンポーネント内で
 * <Image category="common" fileName="logo.png" alt="ロゴ" width={200} />
 * 
 * 注意: 新しい画像を追加する場合は、上部のSTATIC_IMAGESに
 * 静的インポートを追加する必要があります。
 */
